import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import DialogMemoCaution from './DialogMemoCaution';
import { getPatientIcon } from 'src/common/helper';
import { useNotify } from 'src/context/ContextNotify';

type PatientIconsProps = {
  patient: any;
};

const PatientIcons: React.FC<PatientIconsProps> = (props) => {
  const notifyContext = useNotify();
  const [icons, setIcons] = useState(props.patient?.icons || []);
  const [cautionNote, setCautionNote] = useState(
    props.patient?.caution_note || ''
  );
  const [openMemoCaution, setOpenMemoCaution] = useState(false);
  const [iconId, setIconId] = useState(1);

  useEffect(() => {
    setIcons(props.patient?.icons);
    setCautionNote(props.patient?.caution_note);
  }, [props.patient]);

  const handleIconClick = (piconid: number, editable: number) => {
    if (editable !== 1) {
      notifyContext.setNotifyMessage({
        show: true,
        message: '権限がありません',
        type: 'error'
      });
      return;
    }
    try {
      const token = getToken();
      postAPI(`/patient/set-icons?token=${token}`, {
        patientid: props.patient?.id,
        iconid: piconid,
      }).then((res) => {
        if (res && res.code === 200) {
          setIcons(res.data.icons);
        }
      });
    } catch (error) {
      console.error('Failed to fetch data:', error);
      return;
    }
  };

  const handleIconMemoClick = (piconid: number, editable: number) => {
    if (editable !== 1) {
      notifyContext.setNotifyMessage({
        show: true,
        message: '権限がありません',
        type: 'error'
      });
      return;
    }
    setIconId(piconid);
    setOpenMemoCaution(true);
  };

  const handleCloseDialogMemoCaution = () => {
    setOpenMemoCaution(false);
  };

  const handleSave = (data: any) => {
    setOpenMemoCaution(false);
    setCautionNote(data.caution_note);
    setIcons(data.icons);
  };

  return (
    <Stack direction={'row'} justifyContent={'space-between'}>
      {icons &&
        icons.map((icon: any, index: number) => {
          if (icon.namej === '♡') {
            return (
              <Tooltip
                key={index}
                title={icon.note}
                arrow
                PopperProps={{
                  sx: {
                    zIndex: 2147483648,
                  },
                }}
              >
                <Box
                  component='img'
                  height={'24px'}
                  width={'24px'}
                  onClick={() => handleIconMemoClick(icon.piconid, icon.editable)}
                  src={getPatientIcon(icon)}
                  alt={icon.note}
                  sx={{ cursor: 'pointer' }}
                />
              </Tooltip>
            );
          }
          return (
            <Tooltip
              key={index}
              title={icon.note}
              arrow
              PopperProps={{
                sx: {
                  zIndex: 2147483648,
                },
              }}
            >
              <Box
                component='img'
                height={'24px'}
                width={'24px'}
                onClick={() => handleIconClick(icon.piconid, icon.editable)}
                src={getPatientIcon(icon)}
                alt={icon.note}
                sx={{ cursor: 'pointer' }}
              />
            </Tooltip>
          );
        })}
      <DialogMemoCaution
        open={openMemoCaution}
        onClose={handleCloseDialogMemoCaution}
        patientid={props.patient?.id || 0}
        iconId={iconId}
        textMemo={cautionNote || ''}
        handleSave={handleSave}
      />
    </Stack>
  );
};

export default PatientIcons;
